import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('net-sales-routing', []).config([
  '$stateProvider',
  function configuration($stateProvider) {
    $stateProvider.state('net-sales-history', {
      parent: 'arw',
      url: '/net-sales/history/:retailerNo?',
      template: '<net-sales-history-page></net-sales-history-page>',
      redirectTo: 'permissions-denied',
      params: {
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Sales History')));
          },
        ],
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/net-sales/net-sales-widget-routing-module.js